import { Reducer } from "redux";
import { 
  IReturnsState, 
  ReturnsActionEnum, 
  ReturnsActions 
} from ".";

export const initialState: IReturnsState = {
  showReturnsPanel: false,
  sourceAuctions: [],
  isLoading: false,
  isSubmitting: false,
  errorMessage: '',
};

/**
 * The reducer for the returns panel state. It handles the following actions:
 * 
 * - `ReturnsActionEnum.ShowReturnsPanel`: Sets the showPanel flag to true and sets the auction to the given auction.
 * - `ReturnsActionEnum.HideReturnsPanel`: Sets the showPanel flag to false.
 * - `ReturnsActionEnum.FetchCapacityReturns`: Sets the isLoading flag to true and sets the auction to the given auction.
 * - `ReturnsActionEnum.FetchCapacityReturnsSuccess`: Sets the isLoading flag to false and sets the sourceAuctions to the given source auctions.
 * - `ReturnsActionEnum.FetchCapacityReturnsFailed`: Sets the isLoading flag to false and sets the error to the given error.
 * - `ReturnsActionEnum.SubmitCapacityReturn`: Sets the isSubmitting flag to true and sets the error and returnSubmissionResponse to undefined.
 * - `ReturnsActionEnum.SubmitCapacityReturnSuccess`: Sets the isSubmitting flag to false and sets the returnSubmissionResponse to the given response.
 * - `ReturnsActionEnum.SubmitCapacityReturnFailed`: Sets the isSubmitting flag to false and sets the error to the given error.
 */
export const ReturnsReducer: Reducer<IReturnsState, ReturnsActions> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case ReturnsActionEnum.ShowReturnsPanel:
      return {
        ...state,
        showReturnsPanel: true,
        auction: action.auction,
      };
    case ReturnsActionEnum.HideReturnsPanel:
      return {
        ...state,
        showReturnsPanel: false,
        returnSubmissionResponse: undefined, // Clear the submission response when closing the panel
        errorMessage: '', // Clear any error messages when closing the panel
      };
    case ReturnsActionEnum.FetchCapacityReturns:
      return {
        ...state,
        isLoading: true,
        auction: action.auction,
      };
    case ReturnsActionEnum.FetchCapacityReturnsSuccess:
      return {
        ...state,
        isLoading: false,
        sourceAuctions: action.sourceAuctions,
        auction: action.auction,
      };
    case ReturnsActionEnum.FetchCapacityReturnsFailed:
      return {
        ...state,
        isLoading: false,
        errorMessage: action.error,
      };
    case ReturnsActionEnum.SubmitCapacityReturn:
      return {
        ...state,
        isSubmitting: true,
        errorMessage: '',
        returnSubmissionResponse: undefined,
      };
    case ReturnsActionEnum.SubmitCapacityReturnSuccess:
      return {
        ...state,
        isSubmitting: false,
        returnSubmissionResponse: action.response,
      };
    case ReturnsActionEnum.SubmitCapacityReturnFailed:
      return {
        ...state,
        isSubmitting: false,
        errorMessage: action.error,
      };
    default:
      return state;
  }
};